import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/categories';

export default function ArticleCards() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3 whitespace-nowrap">
            SEO Guides
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            Complete <span className="text-primary-500">Sugargoo Spreadsheet</span> Knowledge Base
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            In-depth guides covering everything you need to know about Sugargoo — from beginner tutorials to advanced shopping strategies and honest reviews.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleCards.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={scrollToTop}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full aspect-[3/2] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-semibold whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-800 group-hover:text-primary-600 transition-colors leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-500 font-medium">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}